import React, { ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

import CommonMessages from '~/core/commonMessages';

export const formattedScore = (
    winningScore: number,
    losingScore: number,
    isTied: boolean,
    leadingTeamAbbrev: string
): ReactNode => (
    <FormattedMessage
        description="A formatted game score"
        defaultMessage="{winningScore}-{losingScore} {scoreDetail}"
        values={{
            winningScore: winningScore,
            losingScore: losingScore,
            scoreDetail: isTied ? (
                <FormattedMessage {...CommonMessages.statsDescriptions.long.tied} />
            ) : (
                leadingTeamAbbrev
            ),
        }}
    />
);

export const formatGameScore = (
    homeScore: number,
    awayScore: number,
    leadingTeamAbbrev: string
): ReactNode | string => {
    if (homeScore === awayScore) {
        return formattedScore(homeScore, awayScore, true, leadingTeamAbbrev);
    }
    return homeScore > awayScore
        ? formattedScore(homeScore, awayScore, false, leadingTeamAbbrev)
        : formattedScore(awayScore, homeScore, false, leadingTeamAbbrev);
};
